export const SportTypesIds = {
	HORSE: 31,
	GREYHOUNDS: 184,
};

export const SportTypesUrls = {
	HORSE: "horse-racing",
	GREYHOUNDS: "greyhounds",
};

export const SportTypesUrlIds = {
	[SportTypesUrls.HORSE]: SportTypesIds.HORSE,
	[SportTypesUrls.GREYHOUNDS]: SportTypesIds.GREYHOUNDS,
};

export const SportTypesIdsUrls = {
	[SportTypesIds.HORSE]: SportTypesUrls.HORSE,
	[SportTypesIds.GREYHOUNDS]: SportTypesUrls.GREYHOUNDS,
};
